import { TSetNewEmailReq } from "@sharedTypes/req.type";
import { TSetNewEmailRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function SetNewEmail(otp: string, oldEmail: string, newEmail: string) {
  const apiUrl = "/email/setnewemail";

  const body: TSetNewEmailReq = {
    otp,
    oldEmail,
    newEmail,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TSetNewEmailRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
